document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".faq__question").forEach(btn => {
    btn.addEventListener("click", () => {
        const item = btn.parentElement;
        const expanded = btn.getAttribute("aria-expanded") === "true";

        document.querySelectorAll(".faq__question")
            .forEach(q => q.setAttribute("aria-expanded", "false"));

        document.querySelectorAll(".faq__item")
            .forEach(i => i.classList.remove("open"));

        if (!expanded) {
            item.classList.add("open");
            btn.setAttribute("aria-expanded", "true");
        }
    });
  });

    document.querySelectorAll(".faq__categories li").forEach(filter => {
        filter.addEventListener("click", () => {
            const category = filter.dataset.category;

            document.querySelectorAll(".faq__categories li")
            .forEach(f => f.classList.remove("active"));
            filter.classList.add("active");

            document.querySelectorAll(".faq__item")
            .forEach(item => item.classList.remove("open"));

            document.querySelectorAll(".faq__item").forEach(item => {
            // item.style.display =
            //     category === "all" || item.dataset.category === category
            //     ? "block"
            //     : "none";
            item.style.display =
                category === "all" || item.dataset.category === category
                    ? ""
                    : "none";
            });
        });
    });

    const select = document.querySelector(".faq__category-select");
        if (select) {
        select.addEventListener("change", () => {
            const category = select.value;

            document.querySelectorAll(".faq__item").forEach(item => {
            item.classList.remove("open");
            item.style.display =
                category === "all" || item.dataset.category === category
                ? ""
                : "none";
            });
        });
    }

});


